<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="p-3">
        <span
          class="d-flex justify-content-between align-items-center globalborder-btm-header pb-2 mb-3">
          <span class="col-auto d-flex gap-3 align-items-center">
            <div>
              <h2 class="mb-0">
                Proposal line item # {{ orderItemLineNumber }}
              </h2>
            </div>
            <a>
              Proposal # <b>{{ quoteId }}</b>
            </a>
          </span>
          <span>
            <span
              *ngIf="isModal"
              (click)="closeProposalLineModal()"
              class="cross-border"
              ><i class="pi pi-times"></i
            ></span>
          </span>
        </span>

        <div class="row adduser-container-hgt">
          <form [formGroup]="quoteItemLine">
            <div class="orders-srcvendor pb-4 mb-2">
              <div
                class="row"
                class="row collapseable"
                [ngClass]="{ active: collapseStatus }">
                <div class="col-4">
                  <div class="gray-bg-rounded">
                    <jni-line-vendor
                      #vendor
                      [parent]="quoteItemLine"
                      (vendorAccountEvent)="getVendorAccountField($event)"
                      (vendorObjectEvent)="getVendorObject($event)"
                      [formErrors]="formErrors"
                      (validationErrorEvent)="logValidationErrors()"
                      [poAssignment]="poAssignment"
                      [quoteOrderLine]="quoteOrderLine"
                      [vendorAccountNumber]="
                        vendorAccountNumber
                      "></jni-line-vendor>
                  </div>
                </div>
                <div class="col-4">
                  <div class="gray-bg-rounded">
                    <jni-line-ship-to
                      #shipTo
                      [parent]="quoteItemLine"
                      [deliveryAddress]="deliveryAddress"
                      [countryRegionList]="countryRegionList"
                      [vendroAddressBookObject]="vendroAddressBookObject"
                      [addressObject]="addressObject"
                      [headerObject]="headerObject"
                      [customerList]="customerLists"
                      [showAddress]="showAddress"
                      [formErrors]="formErrors"
                      (validationErrorEvent)="
                        logValidationErrors()
                      "></jni-line-ship-to>
                  </div>
                </div>
                <div class="col-4">
                  <div class="gray-bg-rounded">
                    <jni-line-item-details
                      #details
                      [parent]="quoteItemLine"
                      [shippingProductsList]="shippingProductsList"
                      [customerId]="customerId"
                      [headerShipDate]="shipDate"
                      [headerInhandDate]="inHandDate"
                      [formErrors]="formErrors"
                      (validationErrorEvent)="
                        logValidationErrors()
                      "></jni-line-item-details>
                    <div class="d-flex justify-content-end mt-minus">
                      <div class="border-0 collapse-section d-flex">
                        <a
                          class="btn-collapse"
                          (click)="onToggle()"
                          [ngClass]="{ active: collapseStatus }"
                          >{{ collapseHeading }}
                          <i class="icon-angle-double"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col" *ngIf="showHistory">
              <div class="row">
                <div class="col">
                  <div
                    class="mb-2 text-right"
                    style="
                      text-align: right;
                      color: #0085fe;
                      font-size: 0.875rem;
                    ">
                    Copied from
                    <a (click)="redirectToCopiedFrom()" class="link bold mx-2"
                      >{{ setCopiedFromInfo() }}
                    </a>
                    {{ quoteLineObject?.createdDate | date: "MM-dd-yyyy" }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="gray-bg-rounded">
                  <jni-line-detail
                    #lineDetail
                    [parent]="quoteItemLine"
                    [currencyList]="currencyList"
                    [releasedProductsList]="releasedProductsList"
                    [sellCurrencyStatus]="sellCurrencyStatus"
                    [formErrors]="formErrors"
                    (validationErrorEvent)="logValidationErrors()"
                    [netFieldStatus]="netFieldStatus"></jni-line-detail>
                </div>
              </div>
              <div class="col" formGroupName="lines">
                <div class="col-12">
                  <div class="gray-bg-rounded">
                    <div class="row">
                      <div class="col">
                        <div class="form-group has-float-label">
                          <div class="d-flex justify-content-between">
                            <label class="form-label">Description</label>
                            <a
                              (click)="
                                showPositionDialogDescription('bottomright')
                              "
                              class="link bold fontbold text-underline"
                              >Stock Phrase</a
                            >
                          </div>
                          <textarea
                            pInputText
                            jniAutoCompleteBlocker
                            cols="30"
                            rows="18"
                            class="form-control b-height"
                            formControlName="lineDescriptionD365"
                            (focusout)="
                              applylineDescriptionLengthValidation($event)
                            "></textarea>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group has-float-label">
                          <div class="d-flex justify-content-between">
                            <label class="form-label">Factory notes</label>

                            <a
                              (click)="showPositionDialogFactory('bottomright')"
                              class="link bold fontbold text-underline"
                              >Stock Phrase</a
                            >
                          </div>

                          <textarea
                            pInputText
                            cols="30"
                            rows="18"
                            jniAutoCompleteBlocker
                            class="form-control b-height"
                            formControlName="factoryNotes"
                            (focusout)="
                              applyfactoryNotesLengthValidation($event)
                            "></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex py-3 justify-content-between"
              [class.has-sticky]="compLoaded">
              <div class="d-flex gap-3">
                <p-button label="Copy Header" (click)="next('Copy Header')" />

                <p-button label="Copy Line" (click)="next('Copy Line')" />

                <p-button label="Add Setup" (click)="next('Add Setup')" />

                <!-- <button
                  type="button"
                  title="Create new line with same Vendor, Ship To and Header Details"
                  class="btn btn-primary me-3"
                  (click)="next('Copy Header')">
                  Copy Header
                </button>
                <button
                  type="button"
                  title="Create new line as Copy of current line"
                  class="btn btn-primary me-3"
                  (click)="next('Copy Line')">
                  Copy Line
                </button>
                <button
                  type="button"
                  title="Create new Set-Up Charge line"
                  class="btn btn-primary"
                  (click)="next('Add Setup')">
                  Add Setup
                </button> -->
              </div>

              <div class="d-flex gap-3">
                <p-button label="Cancel" (click)="redirectToSummary()" />

                <p-button label="Done" (click)="onSubmit()" />

                <p-button label=" Add Line" (click)="next('Add Line')" />

                <!-- <button
                  type="button"
                  class="btn btn-secondary me-3"
                  (click)="redirectToSummary()">
                  Cancel
                </button>
                <button
                  type="button"
                  class="btn btn-primary me-3"
                  (click)="onSubmit()">
                  Done
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="next('Add Line')">
                  Add Line
                </button> -->
              </div>
            </div>
          </form>
        </div>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders py-0">
  <header class="orders-header has-border align-items-center d-flex pb-2 mb-2">
    <h1 class="m-0">Proposal line item # {{ orderItemLineNumber }}</h1>
    <h1 class="mx-3">
      Proposal# <b>{{ quoteId }}</b>
    </h1>
  </header>
  <form [formGroup]="quoteItemLine">
    <div class="orders-srcvendor pb-4 mb-2">
      <div
        class="row"
        class="row collapseable"
        [ngClass]="{ active: collapseStatus }">
        <div class="col border-end">
          <jni-line-vendor
            #vendor
            [parent]="quoteItemLine"
            (vendorAccountEvent)="getVendorAccountField($event)"
            (vendorObjectEvent)="getVendorObject($event)"
            [formErrors]="formErrors"
            (validationErrorEvent)="logValidationErrors()"
            [poAssignment]="poAssignment"
            [quoteOrderLine]="quoteOrderLine"
            [vendorAccountNumber]="vendorAccountNumber"></jni-line-vendor>
        </div>
        <div class="col border-end">
          <jni-line-ship-to
            #shipTo
            [parent]="quoteItemLine"
            [deliveryAddress]="deliveryAddress"
            [countryRegionList]="countryRegionList"
            [vendroAddressBookObject]="vendroAddressBookObject"
            [addressObject]="addressObject"
            [headerObject]="headerObject"
            [customerList]="customerLists"
            [showAddress]="showAddress"
            [formErrors]="formErrors"
            (validationErrorEvent)="logValidationErrors()"></jni-line-ship-to>
        </div>
        <div class="col">
          <jni-line-item-details
            #details
            [parent]="quoteItemLine"
            [shippingProductsList]="shippingProductsList"
            [customerId]="customerId"
            [headerShipDate]="shipDate"
            [headerInhandDate]="inHandDate"
            [formErrors]="formErrors"
            (validationErrorEvent)="
              logValidationErrors()
            "></jni-line-item-details>
          <div class="d-flex justify-content-end mt-minus">
            <div class="border-0 collapse-section d-flex">
              <a
                class="btn-collapse"
                (click)="onToggle()"
                [ngClass]="{ active: collapseStatus }"
                >{{ collapseHeading }} <i class="icon-angle-double"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col" *ngIf="showHistory">
      <div class="row">
        <div class="col">
          <div
            class="mb-2 text-right"
            style="text-align: right; color: #0085fe; font-size: 0.875rem">
            Copied from
            <a (click)="redirectToCopiedFrom()" class="link bold mx-2"
              >{{ setCopiedFromInfo() }}
            </a>
            {{ quoteLineObject?.createdDate | date: "MM-dd-yyyy" }}
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col border-end">
        <jni-line-detail
          #lineDetail
          [parent]="quoteItemLine"
          [currencyList]="currencyList"
          [releasedProductsList]="releasedProductsList"
          [sellCurrencyStatus]="sellCurrencyStatus"
          [formErrors]="formErrors"
          (validationErrorEvent)="logValidationErrors()"
          [netFieldStatus]="netFieldStatus"></jni-line-detail>
      </div>
      <div class="col" formGroupName="lines">
        <div class="row">
          <div class="col">
            <div class="mb-2 text-right" style="text-align: right">
              <a
                (click)="showPositionDialogDescription('bottomright')"
                class="link bold"
                >Stock Phrase</a
              >
            </div>
            <div class="form-group has-float-label">
              <textarea pInputText 
                jniAutoCompleteBlocker
                class="form-control b-height"
                formControlName="lineDescriptionD365"
                (focusout)="
                  applylineDescriptionLengthValidation($event)
                "></textarea>
              <label class="form-label">Description</label>
            </div>
          </div>
          <div class="col">
            <div class="mb-2 text-right" style="text-align: right">
              <a
                (click)="showPositionDialogFactory('bottomright')"
                class="link bold"
                >Stock Phrase</a
              >
            </div>
            <div class="form-group has-float-label">
              <textarea pInputText 
                jniAutoCompleteBlocker
                class="form-control b-height"
                formControlName="factoryNotes"
                (focusout)="
                  applyfactoryNotesLengthValidation($event)
                "></textarea>
              <label class="form-label">Factory notes</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex py-3 justify-content-between"
      [class.has-sticky]="compLoaded">
      <div>
        <button
          type="button"
          title="Create new line with same Vendor, Ship To and Header Details"
          class="btn btn-primary me-3"
          (click)="next('Copy Header')">
          Copy Header
        </button>
        <button
          type="button"
          title="Create new line as Copy of current line"
          class="btn btn-primary me-3"
          (click)="next('Copy Line')">
          Copy Line
        </button>
        <button
          type="button"
          title="Create new Set-Up Charge line"
          class="btn btn-primary"
          (click)="next('Add Setup')">
          Add Setup
        </button>
      </div>

      <div>
        <button
          type="button"
          class="btn btn-secondary me-3"
          (click)="redirectToSummary()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary me-3" (click)="onSubmit()">
          Done
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="next('Add Line')">
          Add Line
        </button>
      </div>
    </div>
  </form>
</div> -->

<jni-stock-phrases
  #stockPhraseDescription
  [flag]="'description'"
  [displayPosition]="displayPositionDescription"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogDescription()"
  (notesAndFactEvent)="getDescription($event)"></jni-stock-phrases>

<jni-stock-phrases
  #stockPhraseFactory
  [flag]="'factory'"
  [displayPosition]="displayPositionFactory"
  [position]="position"
  [displayModal]="displayModal"
  [customerCheckbox]="customerCheckbox"
  [vendorCheckbox]="vendorCheckbox"
  [customerId]="customerId"
  [vendorAccountNumber]="vendorAccountNumber"
  (closeMainModalEvent)="closePositionDialogFactory()"
  (notesAndFactEvent)="getFactory($event)"></jni-stock-phrases>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="copiedFromSalesOrderId"></jni-order-summary>
  </div>
</jni-modal-stacker>
